import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
/**
 * This function is type inference ready and will auto-validate the useForm with the proper values.
 * @param schema - A valid you schema
 * @param useFormProps
 * @returns
 */

export function useFormWithSchema(schema, useFormProps) {
  return useForm(_objectSpread(_objectSpread({}, useFormProps), {}, {
    resolver: yupResolver(schema)
  }));
}
export var validationMap = {
  email: Yup.string().required('Questo campo è obbligatorio').email('E-mail non valida')
};
export var notRequired = Yup.string().notRequired();
export var commonTextValidation = Yup.string().required('Questo campo è obbligatorio');